module.exports = __webpack_public_path__ + "img/120.e2b2c6d0.png";